import { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import MaterialUI from "material-UI";
import { useSolicitarAjuste } from "services/api/AppWeb_Oportunidade/post-solicitar-ajuste";
import * as S from "./styles";

interface Data {
  onClose: () => void;
  dataDetalheOportunidade: any;
  refetchDetalheOportunidade: () => void;
  refetchHistorico: () => void;
}

const ModalSolicitarAjuste = (data: Data) => {
  const [descricao, setDescricao] = useState("");
  const [tentouSalvar, setTentouSalvar] = useState(false);

  const descricaoValida = descricao.trim().length > 0;
  const formValido = descricaoValida;

  const { mutate: mutateSolicitarAjuste, isLoading: isLoadingSolicitarAjuste } =
    useSolicitarAjuste();

  const handleSubmit = () => {
    if (!formValido) {
      setTentouSalvar(true);
      return;
    }

    mutateSolicitarAjuste(
      {
        idOportunidade: data.dataDetalheOportunidade.idOportunidade,
        descricao: descricao.trim(),
      },
      {
        onSuccess: () => {
          data.refetchDetalheOportunidade();
          data.refetchHistorico();
          data.onClose();
        },
      }
    );
  };

  return (
    <S.Content>
      <S.Header>
        <S.Row style={{ justifyContent: "space-between" }}>
          <S.TextTitle>Solicitar ajuste</S.TextTitle>
          <S.CloseButton onClick={data.onClose}>
            <IoCloseOutline size={32} />
          </S.CloseButton>
        </S.Row>
      </S.Header>
      <S.SpaceY space={12} />
      <S.Body>
        <S.MultLineField>
          <S.LabelText>Justificativa (obrigatório)</S.LabelText>
          <S.TextField
            onChange={(e: any) => setDescricao(e.target.value)}
            label="Multiline"
            variant="outlined"
            fullWidth
            multiline
            minRows={4}
            value={descricao}
            inputProps={{ maxLength: 4000 }}
            error={tentouSalvar && !descricaoValida}
          />
          <S.CountText>{descricao.length}/4000</S.CountText>
          {tentouSalvar && !descricaoValida && (
            <S.ErrorText>Campo obrigatório.</S.ErrorText>
          )}
        </S.MultLineField>
        <S.SpaceY space={24} />
        <S.Row style={{ gap: 16 }}>
          <S.Button
            onClick={data.onClose}
            color="#ffffff"
            border="1px solid #A3A3A6"
          >
            <S.TextButton color="#424248">Cancelar</S.TextButton>
          </S.Button>
          <S.Button
            onClick={handleSubmit}
            disabled={isLoadingSolicitarAjuste}
            style={{ opacity: formValido ? 1 : 0.5 }}
          >
            {isLoadingSolicitarAjuste ? (
              <MaterialUI.CircularProgress
                size={22}
                style={{ color: "#ffffff" }}
              />
            ) : (
              <S.TextButton color="#FFFFFF">Solicitar ajuste</S.TextButton>
            )}
          </S.Button>
        </S.Row>
      </S.Body>
    </S.Content>
  );
};

export default ModalSolicitarAjuste;
